import React from 'react';
import styled from 'styled-components';
import { colors } from '../../utils/colors.js';

const Wrapper = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

const Thead = styled.thead`
  background: ${colors.gray[50]};
`;

const Th = styled.th`
  text-align: left;
  padding: 12px 20px;
  color: ${colors.gray[600]};
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
`;

const Td = styled.td`
  padding: 12px 20px;
  border-top: 1px solid ${colors.gray[100]};
  color: ${colors.gray[800]};
  white-space: nowrap;
`;

const Empty = styled.div`
  padding: 40px;
  text-align: center;
  color: ${colors.gray[500]};
`;

export default function DataTable({ columns, rows, loading, emptyMessage = 'Nenhum registro encontrado.' }) {
  if (loading) {
    return (
      <Wrapper>
        <Empty>Carregando...</Empty>
      </Wrapper>
    );
  }

  if (!rows || rows.length === 0) {
    return (
      <Wrapper>
        <Empty>{emptyMessage}</Empty>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Table>
        <Thead>
          <tr>
            {columns.map((col) => (
              <Th key={col.key}>{col.label}</Th>
            ))}
          </tr>
        </Thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={row.id || idx}>
              {columns.map((col) => (
                <Td key={col.key}>{col.render ? col.render(row) : row[col.key]}</Td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </Wrapper>
  );
}
